import React from 'react';
import PropTypes from 'prop-types';
import { NotStarted, InProgress, Complete } from './styled';
import { NOT_STARTED, WORK_IN_PROGRESS, COMPLETE } from './constants';
import { toLower } from '../../../../../util/lodashlike';

/**
 * Status
 * @param type {string}
 * @returns {JSX.Element}
 */
const Status = ({ type = 'Not Started' }) => {
  const matchType = toLower(type);

  return (
    <>
      {matchType === 'not started' && <NotStarted>{NOT_STARTED}</NotStarted>}
      {matchType === 'in progress' && (
        <InProgress>{WORK_IN_PROGRESS}</InProgress>
      )}
      {matchType === 'completed' && <Complete>{COMPLETE}</Complete>}
    </>
  );
};

Status.propTypes = {
  type: PropTypes.string
};

export default Status;
